const ThemeIdEnum = {
	LIGHT: 'light',
	DARK: 'dark',
};
const DEFAULT_THEME_ID = ThemeIdEnum.LIGHT;
const DefaultTheme = {
	ID: DEFAULT_THEME_ID,
};
const ThemeDomEnum = {
	ROOT_ID: 'root-background',
};
const VALID_THEME_IDS = new Set([
	ThemeIdEnum.LIGHT,
	ThemeIdEnum.DARK,
]);
const resolveThemeId = (input, fallback = DEFAULT_THEME_ID) => VALID_THEME_IDS.has(input) ? input : fallback;

export {
	ThemeIdEnum,
	DefaultTheme,
	DEFAULT_THEME_ID,
	ThemeDomEnum,
	resolveThemeId,
};
